import { Injectable } from '@angular/core';
import { CartState, createCartState } from './cart-state.model';
import { CartStateStore } from './cart-state.store';
import { CartStateQuery } from './cart-state.query';
import { CartResponse, IUserCart } from '@legalzoom/cart-sdk';
import { SessionStorageType } from '../../services/tracking/session-storage';

@Injectable({
  providedIn: 'root'
})
export class CartStateService {
  private cartStateQuery: CartStateQuery = new CartStateQuery(this.cartStateStore);
  constructor(
    private cartStateStore: CartStateStore
  ) {
    this._state = createCartState({});
    const storage = sessionStorage.getItem(SessionStorageType.CART);
    if (storage === undefined || storage === null) {
      const cart: CartState = createCartState({});
      this._state = cart;
    } else {
      this._state = JSON.parse(storage);
    }
  }

  public set cartState(cartState: CartState) {
    this.cartStateStore.set([cartState]);
    sessionStorage.setItem(SessionStorageType.CART, JSON.stringify(cartState));
  }

  public get cartState(): CartState {
    if (this.cartStateQuery.getCount() === 1) {
      const cart = this.cartStateQuery.getAll()[0];
      return createCartState({
        cart: cart.cart,
        cartId: cart.cartId,
        cartResponse: cart.cartResponse
      });
    } else {
      const ls = JSON.parse(sessionStorage.getItem(SessionStorageType.CART));
      if (ls === undefined) {
        return null;
      } else {
        return ls;
      }
    }
  }

  private set _state(state: CartState) {
    this.cartStateStore.set([state]);
  }

  private get _state(): CartState {
    if (this.cartStateQuery.getCount() === 1) {
      const state = this.cartStateQuery.getAll()[0];
      return createCartState({
        cartId: state.cartId,
        cart: state.cart,
        cartResponse: state.cartResponse
      });
    } else {
      return null;
    }
  }

  public set cartId(cartId: number) {
    const state = this._state;
    state.cartId = cartId;
    this._state = state;
  }
  public get cartId(): number {
    return this._state.cartId;
  }
  public set cart(cart: IUserCart) {
    const state = this._state;
    state.cart = cart;
    this._state = state;
  }
  public get cart(): IUserCart {
    return this._state.cart;
  }
  public set cartResponse(cartResponse: CartResponse) {
    const state = this._state;
    state.cartResponse = cartResponse;
    this._state = state;
  }
  public get cartResponse(): CartResponse {
    return this._state.cartResponse;
  }
}
